import { Field } from 'formik';
import { useMemo } from 'react';

import { Icon } from '@/components/Icon';

interface InputSelectProps {
  name: string;
  options: { text: string; value: string }[];
  value: string;
  label?: string;
  placeholder?: string;
  description?: string;
  className?: string;
}

export const InputSelect = ({
  label,
  name,
  options = [],
  value,
  placeholder = '-',
  description,
}: InputSelectProps) => {
  const optionsWithEmptyValue = useMemo(
    () => [{ text: placeholder, value: '' }, ...options],
    [placeholder, options]
  );

  return (
    <label className="select-wrapper">
      {label && <span className="select-label">{label}</span>}
      <div className="select-input">
        <Field as="select" name={name} aria-label={`select-${name}`} defaultValue={value}>
          {optionsWithEmptyValue.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </Field>
        <Icon name="chevron-left" />
        {description && <span className="select-description">{description}</span>}
      </div>
    </label>
  );
};
